import React, { Component } from "react";
import { Form, Button, Message, Checkbox } from "semantic-ui-react";

import { connect } from "react-redux";

import {
  saveSubmitter,
  submitterLoaded
} from "../../actions/unauthenticated/submitter";

import {
  validatePhoneNumber,
  displayPhoneNumberToBackend,
  backendPhoneNumberToDisplay
} from "../../util/phone";

class SubmitterEditForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: props.submitter.name || "",
      email: props.submitter.email,
      phone: props.submitter.phone || "",
      allows_email_updates: props.submitter.allows_email_updates,
      allows_sms_updates: props.submitter.allows_sms_updates,
      phone_confirm_code: "",
      submitting: false,
      error: false
    };
  }

  validateForm() {
    return (
      this.state.name.length > 0 &&
      this.state.email.length > 0 &&
      (this.state.phone === "" || validatePhoneNumber(this.state.phone)) &&
      (this.state.phone_confirm_code.length === 0 ||
        this.state.phone_confirm_code.length === 6)
    );
  }

  handleChange = event => {
    let value = event.target.value;
    if (event.target.id === "phone") {
      console.log(value);
      value = displayPhoneNumberToBackend(value);
    }
    this.setState({
      [event.target.id]: value,
      error: false
    });
  };

  handleSave = event => {
    event.preventDefault();
    this.setState({
      submitting: true
    });
    this.props
      .saveSubmitter({
        name: this.state.name,
        phone: this.state.phone || null,
        phone_confirm_code: this.state.phone_confirm_code || null,
        allows_email_updates: this.state.allows_email_updates,
        allows_sms_updates: this.state.allows_sms_updates
      })
      .then(updatedSubmitter => {
        this.setState({
          error: false
        });
        this.props.submitterLoaded(updatedSubmitter);
      })
      .catch(() => {
        this.setState({
          error: true
        });
      })
      .finally(() => {
        this.setState({
          submitting: false
        });
      });
  };

  shouldShowEmailWarning = () => {
    return !this.props.submitter.is_email_confirmed;
  };

  shouldShowPhoneWarning = () => {
    const submitter = this.props.submitter;
    return submitter.phone && !submitter.is_phone_confirmed;
  };

  shouldShowWarning = () => {
    return this.shouldShowEmailWarning() || this.shouldShowPhoneWarning();
  };

  render() {
    return (
      <Form
        loading={this.state.submitting}
        style={{ padding: "0 10px" }}
        warning={this.shouldShowWarning()}
      >
        <Form.Group style={{ marginBottom: "1em" }}>
          <Form.Input
            width={16}
            icon="user"
            iconPosition="left"
            label="Name"
            required
            placeholder="Name"
            value={this.state.name}
            onChange={this.handleChange}
            error={!!this.state.error}
            id="name"
          />
        </Form.Group>
        {this.shouldShowEmailWarning() && (
          <Message warning>
            Your name is required to confirm your email.
          </Message>
        )}
        <Form.Group style={{ marginBottom: "1em" }}>
          <Form.Input
            width={16}
            icon="at"
            iconPosition="left"
            label="Email"
            required
            value={this.state.email}
            error={!!this.state.error}
            type="email"
            disabled
            id="email"
          />
        </Form.Group>
        <Form.Group style={{ marginBottom: "1em" }}>
          <Form.Input
            width={16}
            icon="hashtag"
            iconPosition="left"
            label="Phone number"
            placeholder="(800) 867-5309"
            value={backendPhoneNumberToDisplay(this.state.phone)}
            onChange={this.handleChange}
            error={!!this.state.error}
            type="tel"
            id="phone"
          />
        </Form.Group>
        {this.shouldShowPhoneWarning() && [
          <Message warning>
            Your phone is unconfirmed. Please enter the 6-digit code we sent
            you.
          </Message>,
          <Form.Group style={{ marginBottom: "1em" }} warning>
            <Form.Input
              width={16}
              icon="check circle"
              iconPosition="left"
              label="Phone confirmation code"
              placeholder="123456"
              value={this.state.phone_confirm_code}
              onChange={this.handleChange}
              error={!!this.state.error}
              type="tel"
              id="phone_confirm_code"
            />
          </Form.Group>
        ]}
        <Form.Field>
          <label>Notifications</label>
          <div>
            <Checkbox
              checked={this.state.allows_email_updates}
              onChange={() =>
                this.setState({
                  allows_email_updates: !this.state.allows_email_updates
                })
              }
              label="Send me email notifications about my reimbursements."
            />
          </div>
          {this.props.submitter.phone && (
            <div style={{ marginTop: "0.5em" }}>
              <Checkbox
                checked={this.state.allows_sms_updates}
                onChange={() =>
                  this.setState({
                    allows_sms_updates: !this.state.allows_sms_updates
                  })
                }
                label="Send me SMS notifications about my reimbursements."
              />
            </div>
          )}
        </Form.Field>
        <div style={{ textAlign: "right" }}>
          <Button
            primary
            disabled={!this.validateForm() || this.state.submitting}
            onClick={this.handleSave}
          >
            Save
          </Button>
        </div>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  submitter: state.unauthenticated.submitter,
  saveSubmitter: saveSubmitter(
    state.unauthenticated.submitter.uuid,
    state.unauthenticated.submitter.modify_key
  )
});

const mapDispatchToProps = dispatch => ({
  submitterLoaded: submitter => dispatch(submitterLoaded(submitter))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubmitterEditForm);



// WEBPACK FOOTER //
// ./frontend/src/components/forms/SubmitterEditForm.js